import { render } from "./SiteTheme.vue?vue&type=template&id=a649fc3a"
import script from "./SiteTheme.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteTheme.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteTheme.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a649fc3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a649fc3a', __exports__)) {
    api.reload('a649fc3a', __exports__)
  }
  
  module.hot.accept("./SiteTheme.vue?vue&type=template&id=a649fc3a", () => {
    api.rerender('a649fc3a', render)
  })

}


export default __exports__